import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { availableOptionsX, BAR_CHART_X_AXIS_TYPES } from './utils/index.js';

function XAxisSelect({ selectedX, onSelect }) {
  const handleSelect = (val) => {
    onSelect({
      group: val,
      dataset: availableOptionsX[val][0].value,
    });
  };

  return (
    <div className="flex">
      <div className="text-muted m-r-16">X-Axis</div>
      <ButtonToolbar style={{ width: '190px' }}>
        <DropdownButton
          id="data-type"
          bsStyle="info"
          title={
            BAR_CHART_X_AXIS_TYPES.find((type) => type.value === selectedX).name
          }
          className="btn-block text-capitalize"
          onSelect={(val) => handleSelect(val)}
          pullRight
        >
          {BAR_CHART_X_AXIS_TYPES.map((type, index) => (
            <MenuItem
              key={index}
              active={type.value === selectedX}
              eventKey={type.value}
            >
              {type.name}
            </MenuItem>
          ))}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default XAxisSelect;
